import { styled } from '@material-ui/core'
import React from 'react'

const StyledLogo = styled('svg')(({theme})=>({
    width: '100px',
    height: 'auto',
    [theme.breakpoints.up('md')]:{
        width: '150px'
    }

}))
export default function Logo() {
  return (
    <StyledLogo xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 164 72.869" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
    <g id="ruby-logo-white" transform="translate(-1217.73 -150.56)">
        <rect id="Rectangle_5" data-name="Rectangle 5" width="15.866" height="42.479" transform="translate(1217.73 168.797)" fill="white"></rect>
        <rect id="Rectangle_6" data-name="Rectangle 6" width="15.866" height="60.716" transform="translate(1302.366 150.56)" fill="white"></rect>
        <path id="Path_11" data-name="Path 11" d="M1243.486,140.886h0a15.866,15.866,0,0,1-15.866-15.87V98.15h15.866Z" transform="translate(31.898 70.643)" fill="white"></path>
        <path id="Path_12" data-name="Path 12" d="M1278.16,140.886a15.866,15.866,0,0,0,15.866-15.87V98.15H1278.16Z" transform="translate(1.669 70.643)" fill="white"></path>
        <path id="Path_13" data-name="Path 13" d="M1455.621,172.736,1443.186,130H1427.3l12.426,42.72v12.008h15.894Z" transform="translate(-85.963 38.701)" fill="white"></path>
        <circle id="Ellipse_5" data-name="Ellipse 5" cx="8.701" cy="8.701" r="8.701" transform="translate(1237.229 168.03)" fill="white"></circle>
        <circle id="Ellipse_6" data-name="Ellipse 6" cx="8.58" cy="8.58" r="8.58" transform="translate(1364.57 168.026)" fill="white"></circle>
        <path id="Path_14" data-name="Path 14" d="M1385.19,97.63v42.953c5.976,0,16.951-3.456,16.951-21.38S1391.166,97.63,1385.19,97.63Z" transform="translate(-62.348 70.954)" fill="white"></path>
        <path id="Path_15" data-name="Path 15" fill="white" d="M1522.5,222.893a2.813,2.813,0,1,1-2.813-2.813,2.813,2.813,0,0,1,2.813,2.813Zm-.5,0a2.307,2.307,0,1,0-.666,1.641A2.3,2.3,0,0,0,1522,222.893Zm-1.869.4.711,1.009h-.607l-.7-.969h-.241v.969h-.542v-2.757h1.081a.836.836,0,0,1,.916.872.767.767,0,0,1-.615.88Zm-.832-.422h.5a.416.416,0,0,0,0-.832h-.506Z" transform="translate(-141.108 -2.285)"></path>
    </g>
</StyledLogo>
  )
}
